import * as THREE from "three";

interface Props {
    color: string
    bgColor: string
}
const Rubber = (props:Props) => {
    const rubber = new THREE.Shape()
        .moveTo(0, 0)
        .lineTo(1, 0)
        .lineTo(1, 6/12)
        .lineTo(-1, 6/12)
        .lineTo(-1, 0)
        .lineTo(0, 0)

  return (
    <mesh position={[0,60.5,10/12]} rotation={[0,0,0]}>
        <shapeGeometry args={[rubber]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
  )
}

export default Rubber